<template>
  <div class="abnormal-maintain">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button :disabled="disabledFlag" @click="add" type="primary">新建异常</el-button>
        <el-button :disabled="disabledFlag" @click="edit" type="primary">编辑异常</el-button>
        <el-button :disabled="disabledFlag" @click="deleteFun" type="danger">删除异常</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      align="left"
      show-header-overflow
      :auto-resize="true"
      border
      resizable
      show-overflow
      highlight-hover-row
      size="mini"
      ref="abnormalTable"
      class="vxe-table-element"
      :data="tableData"
      :min-height="$store.state.app.tableHeight"
      @select-change="handleSelectionChange"
    >
      <vxe-table-column
        v-for="(item, index) in abnormalColumn"
        :key="index"
        :type="item.type"
        :visible="item.visible"
        :fixed="item.fixed"
        :width="item.width"
        :field="item.field"
        :title="item.title"
      ></vxe-table-column>
    </vxe-table>
    <AbnormalDialog
      v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      :dialogTitle="dialogTitle"
      :isEdit="isEdit"
      :editVal="editVal"
      @close="closeDialog"
    />
  </div>
</template>

<script>
  import { abnormalColumn } from '../data';
  import AbnormalDialog from './abnormalDialog';
  import API from '@/api/intermodality/order';
  export default {
    name: 'abnormalMaintain',
    props: ['exceptions'],
    components: {
      AbnormalDialog,
    },
    watch: {
      exceptions(newVal) {
        this.exceptions = newVal;
        this.dealExceptionsData();
      },
    },
    data() {
      return {
        tableData: [],
        abnormalColumn,
        dialogVisible: false,
        dialogTitle: '',
        isEdit: false,
        editVal: {},
        multipleSelection: [],
        disabledFlag: false,
      };
    },
    methods: {
      dealExceptionsData() {
        this.exceptions.forEach((except) => {
          except.exceptionReason = except.exceptionReason === '0' ? '供方导致' : '客户导致';
          except.exceptionType = except.exceptionType === '0' ? '运输异常' : '订单异常';
          except.hasExceptionExpense = except.hasExceptionExpense === 0 ? '无' : '有';
        });
        this.tableData = this.exceptions;
      },
      closeDialog(va) {
        if (va === 'sure') {
          this.$emit('refresh');
        }
        this.dialogVisible = false;
      },
      add() {
        this.dialogVisible = true;
        this.dialogTitle = '新增订单异常';
        this.isEdit = false;
      },
      edit() {
        const selectRecords = this.$refs.abnormalTable.getCheckboxRecords();
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (selectRecords.length > 1) {
          return this.$message({
            showClose: true,
            message: '只能编辑一条数据',
            type: 'error',
          });
        } else {
          const selectObj = selectRecords[0] || {};
          const selectId = selectObj.id || '';
          const selectExceptionCode = selectObj.exceptionCode || '';
          const params = {
            id: selectId,
            exceptionCode: selectExceptionCode,
          };
          this.$axios.post(API.ORDER_ABNORMAL_DETAIL, params).then((res) => {
            if (res.data.code === 0) {
              const data = res.data.data || {};
              this.editVal = data;
              this.dialogVisible = true;
              this.dialogTitle = '编辑订单异常';
              this.isEdit = true;
            }
          });
        }
      },
      deleteFun() {
        const selectRecords = this.$refs.abnormalTable.getCheckboxRecords();
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else {
          const ids = [];
          selectRecords.forEach((select) => {
            ids.push(select.id);
          });
          const params = {
            ids,
          };
          this.$axios.post(API.ORDER_PATCH_DELETE, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success',
              });
              this.$emit('refresh');
            }
          });
        }

        // const fullData = this.$refs.serviceTable.getTableData().fullData || [];
        // if (selectRecords.length < 1) {
        //   return this.$message({
        //     showClose: true,
        //     message: this.$t('xTable.noSelectData'),
        //     type: 'error',
        //   });
        // } else {
        //   this.$confirmAction()
        //     .then(() => {
        //       this.$message({
        //         showClose: true,
        //         type: 'success',
        //         message: this.$t('receivablesManage.message.deleteSuccess'),
        //       });
        //       this.$refs.abnormalTable.removeSelecteds();
        //     })
        //     .catch(() => {});
        // }
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
    },
  };
</script>
